import React, { useState, useEffect } from "react";
import axios from 'axios';
import PropTypes from 'prop-types';

//constants
import { urlAssets } from '../../Constants'; 

//components
import Loading from '../common/Loading';
import QualifiedTeam from './QualifiedTeam';

const QualifiedTeamHome = props => {

    const responseStatusOk = 200;
    const { slugTeam } = props;
    const urlJsonTeam = `${urlAssets}/json/selecciones/${slugTeam}.json`;
    const [team, setTeam] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getTeam = async () => {
            const response = await axios(urlJsonTeam);
            if(response.status === responseStatusOk){
                setTeam(response.data);
                setLoading(false);
            }            
        }           

        getTeam();                        
    },[]);

    return (
        <section className="w-100 cont-team">
            {
                loading 
                ? <Loading />
                : <QualifiedTeam team={team} />
            }
        </section>
    )
}

export default QualifiedTeamHome;

QualifiedTeamHome.propTypes = {
    slugTeam: PropTypes.string.isRequired
}
